var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-app',[_c('router-view',{key:_vm.refreshKey,attrs:{"id":"app"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }